// Theme toggle - stores preference in closure; persists while tab is open
(function () {
  const KEY = 'sleepbaker-theme';
  let saved = null;
  try { saved = localStorage.getItem(KEY); } catch (e) {}

  if (saved === 'dark' || (saved === null && window.matchMedia('(prefers-color-scheme: dark)').matches)) {
    document.documentElement.setAttribute('data-theme', 'dark');
  }
})();

function toggleTheme() {
  const current = document.documentElement.getAttribute('data-theme');
  const next = current === 'dark' ? 'light' : 'dark';
  document.documentElement.setAttribute('data-theme', next);
  try { localStorage.setItem('sleepbaker-theme', next); } catch (e) {}
}

// Mobile menu drawer
(function () {
  function init() {
    var toggle = document.querySelector('[data-menu-toggle]');
    var menu = document.getElementById('sb-mobile-menu');
    var overlay = document.querySelector('[data-menu-overlay]');
    if (!toggle || !menu || !overlay) return;

    function open() {
      document.body.classList.add('sb-menu-open');
      overlay.hidden = false;
      toggle.setAttribute('aria-expanded', 'true');
      menu.setAttribute('aria-hidden', 'false');
    }
    function close() {
      document.body.classList.remove('sb-menu-open');
      toggle.setAttribute('aria-expanded', 'false');
      menu.setAttribute('aria-hidden', 'true');
      // keep overlay in DOM flow but hidden once transition ends
      setTimeout(function () { if (!document.body.classList.contains('sb-menu-open')) overlay.hidden = true; }, 300);
    }
    function toggleMenu() {
      if (document.body.classList.contains('sb-menu-open')) close(); else open();
    }

    toggle.addEventListener('click', toggleMenu);
    overlay.addEventListener('click', close);
    var closeBtn = menu.querySelector('[data-menu-close]');
    if (closeBtn) closeBtn.addEventListener('click', close);
    // close when any link inside the drawer is followed
    menu.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    // close if resized up to desktop
    window.addEventListener('resize', function () { if (window.innerWidth > 900) close(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

// Scroll reveal animation
(function () {
  const elements = document.querySelectorAll('.reveal');
  if (!('IntersectionObserver' in window)) {
    elements.forEach(el => el.classList.add('in'));
    return;
  }
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('in');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1, rootMargin: '0px 0px -60px 0px' });
  elements.forEach(el => observer.observe(el));
})();

// Simple animated stat counter
(function () {
  const stats = document.querySelectorAll('.stat-num');
  const animate = (el) => {
    const text = el.textContent.trim();
    const match = text.match(/^([\d,.]+)/);
    if (!match) return;
    const target = parseFloat(match[1].replace(/,/g, ''));
    if (isNaN(target) || target === 0) return;
    const suffix = text.replace(match[1], '');
    const duration = 1500;
    const start = performance.now();
    const isFloat = match[1].includes('.');
    const step = (now) => {
      const progress = Math.min((now - start) / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      const value = target * eased;
      el.childNodes[0].nodeValue = (isFloat ? value.toFixed(1) : Math.round(value).toLocaleString()) ;
      // put the suffix (small element) back - handled by not overwriting .innerHTML
      if (progress < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  };

  if ('IntersectionObserver' in window) {
    const obs = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) { animate(entry.target); obs.unobserve(entry.target); }
      });
    }, { threshold: 0.4 });
    stats.forEach(s => obs.observe(s));
  }
})();
